import type { GroupedToolCall } from "../group-tool-messages";
import type { ChatToolMessage } from "../types";
import { ToolCallIcon } from "./ToolCallIcon";
import { useToolCallPresentation } from "./useToolCallPresentation";

export const RunningToolCall = ({
  call,
  result,
}: {
  call: GroupedToolCall;
  result?: ChatToolMessage;
}) => {
  const { name, integrationIcon, label } = useToolCallPresentation(
    call,
    result,
    !call.toolCall.error
  );
  return (
    <span className="flex min-w-0 items-center gap-2">
      <ToolCallIcon name={name} integrationIcon={integrationIcon} size={14} />
      <span
        aria-live="polite"
        aria-atomic="true"
        className="min-w-0 truncate"
        title={label}
      >
        {label}
      </span>
    </span>
  );
};
